import {
  BaseError,
  createErrorBuilder,
} from '@wix/public-editor-platform-errors';

export enum AppDependenciesInstallServiceErrorCode {
  CompanionAppDependenciesInstallFailed = 'companionAppDependenciesInstallFailed',
  CompanionAppDependenciesInstallPartialFailure = 'companionAppDependenciesInstallPartialFailure',
}

class AppDependenciesInstallServiceError extends BaseError<AppDependenciesInstallServiceErrorCode> {
  state: Partial<{
    rootAppDefinitionId: string;
    dependencyAppDefinitionIds: string;
    failedAppDefinitionIds: string;
  }> = {};

  constructor(message: string, code: AppDependenciesInstallServiceErrorCode) {
    super(message, code, 'Editor Platform App Dependencies Install Error');
  }

  withRootAppDefinitionId(id: string) {
    this.state = { ...this.state, rootAppDefinitionId: id };
    return this;
  }

  withDependencyAppDefinitionIds(ids: string[]) {
    this.state = { ...this.state, dependencyAppDefinitionIds: ids.join(',') };
    return this;
  }

  withFailedAppDefinitionIds(ids: string[]) {
    this.state = { ...this.state, failedAppDefinitionIds: ids.join(',') };
    return this;
  }
}

export const createAppDependenciesInstallServiceError = createErrorBuilder<
  AppDependenciesInstallServiceErrorCode,
  AppDependenciesInstallServiceError
>(AppDependenciesInstallServiceError);
